import { useTranslation } from 'react-i18next';
import type { DashboardChartResponse } from '../../types/dashboard';
import { DashboardInfoTip } from './DashboardDateFilter';
import { DashboardChartLegend, DashboardDoughnutChart } from './DashboardDoughnutChart';

type DashboardChartCardProps = {
  title: string;
  tooltip: string;
  chart: DashboardChartResponse;
};

export function DashboardChartCard({ title, tooltip, chart }: DashboardChartCardProps) {
  return (
    <div className="dash-chart-card">
      <div className="dash-chart-card__title">{title}</div>
      <div className="dash-chart-card__info-wrap">
        <DashboardInfoTip tooltip={tooltip} tipClassName="dash-chart-card__tip" />
      </div>
      <DashboardDoughnutChart slices={chart.slices} />
      <DashboardChartLegend slices={chart.slices} />
    </div>
  );
}

type DashboardChartsRowProps = {
  urgencyChart: DashboardChartResponse;
  statusChart: DashboardChartResponse;
  categoryChart: DashboardChartResponse;
  i18nPrefix: string;
  dateFromLabel: string;
  dateToLabel: string;
};

export function DashboardChartsRow({
  urgencyChart,
  statusChart,
  categoryChart,
  i18nPrefix,
  dateFromLabel,
  dateToLabel,
}: DashboardChartsRowProps) {
  const { t } = useTranslation();
  const range = { from: dateFromLabel, to: dateToLabel };

  return (
    <div className="dash-charts-row">
      <DashboardChartCard
        title={t(`${i18nPrefix}.charts.urgency`)}
        tooltip={t(`${i18nPrefix}.charts.urgencyTip`, range)}
        chart={urgencyChart}
      />
      <DashboardChartCard
        title={t(`${i18nPrefix}.charts.status`)}
        tooltip={t(`${i18nPrefix}.charts.statusTip`, range)}
        chart={statusChart}
      />
      <DashboardChartCard
        title={t(`${i18nPrefix}.charts.category`)}
        tooltip={t(`${i18nPrefix}.charts.categoryTip`, range)}
        chart={categoryChart}
      />
    </div>
  );
}
